/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProofOfDeliveryPhotoDtoBase
 * auto generated base class for the model ProofOfDeliveryPhotoDtoModel.
 */
export const ProofOfDeliveryPhotoDtoModelBase = ModelBase
  .named('ProofOfDeliveryPhotoDto')
  .props({
    __typename: types.optional(types.literal("ProofOfDeliveryPhotoDTO"), "ProofOfDeliveryPhotoDTO"),
    firebaseStorageUuid: types.union(types.undefined, types.string),
    url: types.union(types.undefined, types.string),
    thumbnail: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProofOfDeliveryPhotoDtoModelSelector extends QueryBuilder {
  get firebaseStorageUuid() { return this.__attr(`firebaseStorageUuid`) }
  get url() { return this.__attr(`url`) }
  get thumbnail() { return this.__attr(`thumbnail`) }
}
export function selectFromProofOfDeliveryPhotoDto() {
  return new ProofOfDeliveryPhotoDtoModelSelector()
}

export const proofOfDeliveryPhotoDtoModelPrimitives = selectFromProofOfDeliveryPhotoDto().firebaseStorageUuid.url.thumbnail
